/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Button, Grid, Paper, Typography } from '@mui/material';
import { AuthService } from 'services';
import { useNavigate } from 'react-router-dom';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, FieldErrors, FormProvider } from 'react-hook-form';
import { z } from 'zod';
import { useLoginForm } from 'hooks';
import {
    SubmitButton,
    FormTextInput,
    ErrorDisplay
} from 'components';
import { CoreRoutes } from 'app-constants';
export const LoginForm = () => {
    const navigate = useNavigate();
    const { schema } = useLoginForm();
    type FormFields = z.infer<typeof schema>;
    const methods = useForm<FormFields>({
        resolver: zodResolver(schema),
        mode: 'onBlur',
    });
    const onSubmit = async (data: FormFields) => {
        try {
            await AuthService.login(data.email, data.password);
            navigate(CoreRoutes.home);
        } catch (e: any) {
            methods.setError('root', { type: 'manual', message: e.message });
        }
    };
    const onError = async (data: FieldErrors<FormFields>) => {
        console.log(data);
    };
    return (
        <>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit, onError)} style={{ width: '25%', height: '80%' }}>
                    <Grid container justifyContent='center' textAlign={'center'} spacing={2} component={Paper} p={5}>
                        <Grid item xs={12}>
                            <img src='/logo.png' alt='Logo' style={{ width: 'auto', height: '132px', margin: 'auto' }} />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant='h4' gutterBottom>
                                Login
                            </Typography>
                        </Grid>
                        <Grid item xs={12} textAlign={'start'} py={1}>
                            <ErrorDisplay message={methods.formState?.errors?.root?.message} />
                        </Grid>
                        <Grid item xs={12} py={1}>
                            <FormTextInput name='email' />
                        </Grid>
                        <Grid item xs={12} py={1}>
                            <FormTextInput name='password' type='password' />
                        </Grid>
                        <Grid item xs={4} textAlign={'center'}>
                            <SubmitButton text='Sign in' />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='text' color='primary' onClick={() => navigate(CoreRoutes.requestPasswordReset)} sx={{ marginTop: 2 }}>
                                Forgot Password?
                            </Button>
                        </Grid>
                    </Grid >
                </form>
            </FormProvider>
        </>
    );
};
